export default __webpack_public_path__ + "static/professor-8-f184eff4f538cd9e3b0c28845ac8a6de.png";